import { createContext } from 'react';

const BookmarksContext = createContext(void 0);

BookmarksContext.displayName = 'context(Bookmarks)';

export default BookmarksContext;